import React from "react";
import { CardIcon } from "icons/payments/Card";
import { BankIconSm } from "icons/payments/BankIconSm";
import { PaymentMethodList } from "types/payments";

export const defaultPaymentMethodList: PaymentMethodList[] = [
  {
    name: "Card",
    icon: React.createElement(CardIcon),
  },
  {
    name: "Bank",
    icon: React.createElement(BankIconSm),
  },
];
